import type { PartRendererProps } from '@/features/chat/registry';
import { useTranslation } from 'react-i18next';
import { callRecordText } from '../call-record';
import '../calls.css';

export function CallRecordPart({part,message,outgoing}:PartRendererProps) {
  const {t}=useTranslation('calls');
  if(message.deleted_at||message.hidden===true)return null;
  const text=callRecordText(part,(key,values)=>t(key,values));
  return text===null?null:<div className={`calls-record${outgoing?' calls-record--outgoing':''}`}>{text}</div>;
}
